import { useEffect, useState } from "react";

import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks";
import { LogoSpinnerComponent } from "../../../lib/spinner/spinnerLogo";
import { Layout } from "../../../ui/layout";
import { ButtonComponent } from "../../../ui/molecules/button/newButton";
import { MadfarmStaticSelect } from "../../../ui/molecules/select/newSelect/static";
import { MenuItems } from "../../../ui/organisms/navbar/dto";
import { OptionType, yearOptions } from "../../../utils";
import { GetByIdAnagraphic, resetGetByIdStatus } from "../../gestionePersonale/boxAnagrafica/slice";
import { GetAllPersonalManagement, resetGetAllPersonalManagementResourcesStatus } from "../../gestionePersonale/slice";
import { GetAllAssignment, resetAssignmentFilters, setAssignmentFilterInspectorCode, setAssignmentFilterYear } from "../../incarichi/slice";
import { AssignmentsListPc } from "./listAssignments";

export function PersonaleContabileView() {
    const dispatch = useAppDispatch()
    const reimbursementState = useAppSelector(state => state.reimbursement)
    const personalManagementState = useAppSelector(state => state.personalManagement)
    const assignmentState = useAppSelector(state => state.assignment)
    const pmAnagraficaState = useAppSelector(state => state.PMAnagrafica)
    const PersonaleContabile = useAppSelector(state => state.PersonaleContabile)
    const [inspectors, setInspectors] = useState<OptionType[]>([])
    const [inspToSearch, setInspToSearch] = useState<string[]>([])

    useEffect(() => {
        dispatch(GetAllPersonalManagement({
            itemsPerPage: 0,
            page: 0,
            function: 'PERSONALE_ISPETTIVO',
            active: true
        }))
    }, [])

    useEffect(() => {
        dispatch(setAssignmentFilterInspectorCode('DABI'))
    }, [])

    useEffect(() => {
        if (personalManagementState.getAllPersonalManagementResourcesStatus === 'successfully' &&
            personalManagementState.getAllPersonalManagementResourcesResponse !== undefined
        ) {
            dispatch(resetGetAllPersonalManagementResourcesStatus())
            const inspectorsIds = personalManagementState.getAllPersonalManagementResourcesResponse.data.map(pm => String(pm.anagraphicId))
            setInspToSearch(inspectorsIds)
        }
    }, [personalManagementState.getAllPersonalManagementResourcesStatus])

    useEffect(() => {
        if (inspToSearch.length > 0) {
            dispatch(GetByIdAnagraphic(inspToSearch[0]))
        }
    }, [inspToSearch])


    useEffect(() => {
        if (pmAnagraficaState.GetByIdAnagraphicStatus === 'successfully' &&
            pmAnagraficaState.getByIdAnagraphicRequest !== undefined
        ) {
            dispatch(resetGetByIdStatus('idle'))

            const data = pmAnagraficaState.getByIdAnagraphicRequest
            const currInspectors = [...inspectors]
            currInspectors.push({
                value: data.identifierCode,
                label: `${data.name} ${data.surname} (${data.identifierCode})`
            } as OptionType)

            setInspectors(currInspectors)
            setInspToSearch(inspToSearch.slice(1))
        }
    }, [pmAnagraficaState.GetByIdAnagraphicStatus])

    if (PersonaleContabile.getAllPersonaleContabiletatus === 'loading') {
        return (
            <LogoSpinnerComponent fullScreen />
        )
    }

    return (
        <Layout
            menuItem={MenuItems.AMMINISTRAZIONE}
            breadcrumbItems={['Amministrazione', 'Gestione Personale - Contabile']}
            noPaddingLat
            headerLabel="Gestione Personale - Contabile"

        >
            <div className="flex flex-row gap-2 items-center px-6 pt-6">
                <MadfarmStaticSelect
                    noOptionsMessage=""
                    placeholder={'Anno'}
                    value={assignmentState.assignmentFilters.year}
                    options={yearOptions}
                    onChange={(value) => {
                        //@ts-ignore
                        const newValue = value !== null ? value.value : null
                        dispatch(setAssignmentFilterYear(newValue))
                    }}
                />
                <MadfarmStaticSelect
                    placeholder='Seleziona ispettore...'
                    options={inspectors}
                    value={assignmentState.assignmentFilters.inspectorCode}
                    onChange={(value) => {
                        //@ts-ignore
                        const newValue = value !== null ? value.value : null
                        dispatch(setAssignmentFilterInspectorCode(newValue))
                    }
                    }
                    noOptionsMessage={"Nessun ispettore trovato"}
                />
                <div className="w-[15%] flex flex-row items-center gap-2">
                    <ButtonComponent
                        size={"lg"}
                        iconPosition={"off"}
                        variant={"outline"}
                        label="Pulisci"
                        color={"gray"}
                        onClick={() => dispatch(resetAssignmentFilters())}
                        fullWidth
                    />
                    <ButtonComponent
                        disabled={assignmentState.assignmentFilters.year === undefined || assignmentState.assignmentFilters.inspectorCode === undefined}
                        size={"lg"}
                        iconPosition={"off"}
                        variant={"outline"}
                        label="Cerca"
                        color={"orange"}
                        onClick={() => dispatch(GetAllAssignment(assignmentState.assignmentFilters))}
                        fullWidth
                    />
                </div>
            </div>
            <AssignmentsListPc />
        </Layout>
    )
}